<template>
    <div class="row">
        <div class="col-md-6">
            <form method="POST" @submit.prevent="uploadFile" enctype="multipart/form-data">
                <input type="file" id="file" ref="file" accept="image/*">
                <button class="btn btn-primary" type="submit">Upload</button>
            </form>
        </div>
        <div class="col-md-6" v-if="file_url != null">
            <h3>Here is the logo:</h3>
            <img :src="file_url" class="img-fluid" alt="School Logo">
        </div>
    </div>
</template>

<script>
export default {
  props: ["file"],
  data() {
    return {
        file_url: this.file,
        uploadProgress: 0
    }
  },
  methods: {
      uploadFile() {
          Vapor.store(this.$refs.file.files[0], {
            progress: progress => {
                this.uploadProgress = Math.round(progress * 100);
            }
            }).then(response => {
                axios.post('/admin/logo/upload', {
                    uuid: response.uuid,
                    key: response.key,
                    bucket: response.bucket,
                    name: this.$refs.file.files[0].name,
                    content_type: this.$refs.file.files[0].type,
                })
                window.location.href = "/admin/school-logo";
            });
      }
  }
};
</script>
